import { newsFeed } from '@/mocks/home';

export default function NewsTimeline() {
  return (
    <div id="feed" className="lg:col-span-1 scroll-mt-16">
      <p className="text-xs tracking-[0.25em] text-accent-700 font-label">LIVE · 快讯流</p>
      <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
        从早到晚的更新记录
      </h2>

      <div className="mt-6">
        {newsFeed.map((item, idx) => (
          <div key={item.id} className="flex gap-4">
            <span className="w-11 shrink-0 pt-0.5 font-label text-xs text-foreground-500">{item.time}</span>
            <div className="relative flex flex-col items-center">
              <span className="w-2.5 h-2.5 rounded-full bg-accent-500 ring-4 ring-accent-100" />
              {idx !== newsFeed.length - 1 && <span className="flex-1 w-px bg-foreground-950/12 my-1" />}
            </div>
            <div className={`flex-1 min-w-0 ${idx !== newsFeed.length - 1 ? 'pb-6' : ''}`}>
              <p className="text-sm font-medium text-foreground-900">{item.title}</p>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.note}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}